export default "__VITE_ASSET__d8bc5667__"